import * as Comlink from 'comlink'
import captureUploadImages from './captureUploadImages'
import {CAPTURE_UPLOAD_WORKER_SCRIPT_URL, PREFIX_LOG} from '../constants/captureUpload'

export const checkWorkerSupport = () => {
    try {
        return typeof Worker !== 'undefined'
    } catch (e) {
        return false
    }
}

/**
 * Upload captured sides to S3 using Web Worker (non-blocking) or fallback to sync
 * 
 * Pattern similar to composite.js
 * 
 * @param {Array} sidesData - [{blob: Blob, presignedUrl: string, side: string}, ...]
 * @param {Object} options - {useWorker: boolean}
 * @returns {Promise<Array>} [{side: string, url: string, success: boolean}, ...]
 */
export default async function captureUpload(sidesData = [], options = {}) {
    const {useWorker = true} = options
    
    const isWorkerSupported = checkWorkerSupport()
    
    if (!isWorkerSupported) {
        console.warn(`${PREFIX_LOG} Worker is not supported`)
    }
    
    // Use sync method if worker is disabled or not supported
    if (!useWorker || !isWorkerSupported) {
        return captureUploadImages(sidesData)
    }
    
    // Use worker for non-blocking upload
    try {
        const worker = new Worker(CAPTURE_UPLOAD_WORKER_SCRIPT_URL)
        const remoteUploadFn = Comlink.wrap(worker)
        const results = await remoteUploadFn(sidesData)
        
        // Terminate worker after use
        worker.terminate()
        
        return results
    } catch (error) {
        console.error(`${PREFIX_LOG} ❌ Worker upload failed, falling back to sync:`, error)
        
        // Fallback to sync method on error
        return captureUploadImages(sidesData)
    }
}
